import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, EQUIPMENT_LIST, fmtErr } from "@/lib/api";

export default function GroupsTab() {
  const [groups, setGroups] = useState([]);
  const [members, setMembers] = useState([]);
  const [name, setName] = useState("");

  const load = () => {
    api.get("/coach/groups").then((r) => setGroups(r.data)).catch((e) => toast.error(fmtErr(e)));
    api.get("/coach/members").then((r) => setMembers(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await api.post("/coach/groups", { name: name.trim() });
    setName("");
    toast.success("Group created");
    load();
  };

  const toggleEquip = async (g, id) => {
    const equipment = g.equipment.includes(id) ? g.equipment.filter((x) => x !== id) : [...g.equipment, id];
    await api.put(`/coach/groups/${g.id}`, { equipment });
    load();
  };

  return (
    <div data-testid="coach-groups">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <h2 className="font-display uppercase text-4xl">Groups <span className="text-zinc-600">({groups.length})</span></h2>
        <form onSubmit={create} className="flex gap-2">
          <input data-testid="group-name-input" value={name} onChange={(e) => setName(e.target.value)}
            placeholder="New group name" className="bg-zinc-950 border border-zinc-700 px-4 py-3 text-sm focus:border-volt outline-none" />
          <button data-testid="group-create" className="bg-volt text-black text-xs uppercase tracking-[0.16em] font-extrabold px-5 py-3 hover:bg-white transition-colors">Create</button>
        </form>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {groups.map((g) => (
          <div key={g.id} data-testid={`group-card-${g.id}`} className="border border-zinc-800 bg-zinc-950 p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-display uppercase text-2xl">{g.name}</h3>
              {g.is_default && <span className="text-[9px] uppercase tracking-[0.2em] font-extrabold text-black bg-volt px-2 py-1">Homepage group</span>}
            </div>
            <p className="text-xs text-zinc-500 mt-1">
              {g.member_ids.length} member(s): {g.member_ids.map((id) => members.find((m) => m.user_id === id)?.name || id).join(", ") || "none yet"}
            </p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold mt-5 mb-2">Shared equipment (sessions only use this kit)</p>
            <div className="flex flex-wrap gap-2">
              {EQUIPMENT_LIST.map((e) => (
                <button key={e.id} data-testid={`group-${g.id}-equip-${e.id}`} onClick={() => toggleEquip(g, e.id)}
                  className={`border px-2.5 py-1.5 text-[10px] uppercase tracking-[0.1em] font-bold transition-colors ${g.equipment.includes(e.id) ? "bg-volt text-black border-volt" : "border-zinc-700 text-zinc-500 hover:border-volt"}`}>
                  {e.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-zinc-600 mt-4">Assign members to groups from the Members tab. Plans generated for a group instantly appear on every member's dashboard in that group.</p>
    </div>
  );
}
